// Third-party SDKs (analytics, marketing, session replay) compete with the first route for the main
// thread and network; the route's chunk, data and map usually settle within this window after `load`.
export const PAGE_SETTLE_DELAY_MS = 4000;
const IDLE_TIMEOUT_MS = 2000;

type Task = () => void;

const runWhenIdle = (task: Task) => {
  if (typeof window.requestIdleCallback === 'function') {
    window.requestIdleCallback(task, { timeout: IDLE_TIMEOUT_MS });
    return;
  }
  // Safari has no requestIdleCallback.
  window.setTimeout(task, 0);
};

const afterLoad = (callback: () => void) => {
  if (document.readyState === 'complete') {
    callback();
    return;
  }
  window.addEventListener('load', callback, { once: true });
};

/** Runs `task` in an idle slot a few seconds after `load`, so it never competes with the initial route. */
export const runAfterPageSettles = (task: Task) => {
  if (typeof window === 'undefined') return;
  afterLoad(() => window.setTimeout(() => runWhenIdle(task), PAGE_SETTLE_DELAY_MS));
};
